export const calendarImage = {
  arrowNext: 'assets/img/profile/calendar/arrow_next.svg',
  arrowPrevious: 'assets/img/profile/calendar/arrow_previous.svg'
};
